var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgElleAccordion = function SvgElleAccordion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m11.998 17-.848-.849 8.567-8.569a.6.6 0 1 1 .849.849L11.998 17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m12.852 16.146-.851.852-8.575-8.566a.602.602 0 1 1 .85-.852l8.576 8.566Z"
  })));
};
export default SvgElleAccordion;